import styled from '@emotion/styled';
import { Box } from '@mantine/core';

import { mediaQueryTablet } from '~/styles/mixins';

const PageSection = styled(Box)`
  position: relative;
  padding: 0 24px;
  width: 100%;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  ${mediaQueryTablet} {
    padding: 0 16px;
  }
`;
PageSection.defaultProps = { component: 'section' };

export default PageSection;
